<template>
  <div style="display: flex; align-items: flex-start">
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>Hibák</span>
      </div>

      <table-filter
        :config="config"
        action="errorLog/fetchAllWithPagination"
      />

      <div v-loading="loading">
        <el-table
          :data="errorLogs.data || []"
          style="width: 100%"
          row-key="id"
        >
          <el-table-column
            label="Súlyosság"
            width="130"
          >
            <template slot-scope="scope">
              <el-tag
                :type="severityTagType(scope.row.severity)"
                size="small"
              >
                {{ severityLabel(scope.row.severity) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Forrás"
            width="150"
          >
            <template slot-scope="scope">
              {{ sourceLabel(scope.row.source) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Kapcsolódó"
            width="200"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.errorable_type">
                {{ entityLabel(scope.row.errorable_type) }} #{{ scope.row.errorable_id }}
              </span>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Cím"
            width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.title || '—' }}
            </template>
          </el-table-column>
          <el-table-column
            label="Üzenet"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.message"
                class="error-log-message"
                style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #409eff; cursor: pointer;"
                @click="showMessage(scope.row)"
              >
                {{ scope.row.message }}
              </span>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Időpont"
            width="160"
            prop="created_at"
          />
          <el-table-column
            label="Állapot"
            width="180"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.resolved_at"
                type="success"
                size="small"
              >
                Lezárt{{ resolverName(scope.row) }}
              </el-tag>
              <el-tag
                v-else
                type="info"
                size="small"
              >
                Nyitott
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Műveletek"
            width="120"
            align="right"
          >
            <template slot-scope="scope">
              <Actions
                :error-log="scope.row"
                @show-message="showMessage"
                @show-xml="showXml"
              />
            </template>
          </el-table-column>
        </el-table>

        <div class="el-card-footer">
          <el-pagination
            background
            :current-page.sync="currentPage"
            :page-size="errorLogs && errorLogs.per_page"
            layout="total, prev, pager, next"
            :total="errorLogs && errorLogs.total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>

    <el-dialog
      title="Hibaüzenet"
      :visible.sync="messageDialogVisible"
      width="600px"
      append-to-body
    >
      <pre
        class="error-log-message-full"
        style="margin: 0; max-height: 60vh; overflow: auto; white-space: pre-wrap; word-break: break-word; font-family: inherit;"
      >{{ selectedMessage }}</pre>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="messageDialogVisible = false">
          Bezárás
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-document-copy"
          @click="copyMessage"
        >
          Másolás
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="xmlFileName || 'XML fájl'"
      :visible.sync="xmlDialogVisible"
      width="800px"
      append-to-body
    >
      <pre
        v-loading="xmlLoading"
        class="error-log-xml-content"
        style="margin: 0; max-height: 60vh; overflow: auto; white-space: pre-wrap; word-break: break-word; background: #f5f7fa; padding: 12px; border-radius: 4px;"
      ><code style="font-family: 'Courier New', Courier, monospace; font-size: 12px;">{{ selectedXmlContent }}</code></pre>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="xmlDialogVisible = false">
          Bezárás
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-document-copy"
          :disabled="!selectedXmlContent"
          @click="copyXml"
        >
          Másolás
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableFilter from '../../components/TableFilter';
import Actions from '../../components/errorLogs/Actions';
import {
  sourceOptions,
  severityOptions,
  sourceLabel,
  severityLabel,
  severityTagType,
  entityLabel,
} from './labels';

export default {
  components: {
    TableFilter,
    Actions,
  },
  data() {
    return {
      currentPage: 1,
      messageDialogVisible: false,
      selectedMessage: '',
      xmlDialogVisible: false,
      xmlLoading: false,
      xmlFileName: '',
      selectedXmlContent: '',
      config: [
        {
          type: 'select',
          name: 'resolved',
          label: 'Állapot',
          options: [
            { value: 0, label: 'Lezáratlan' },
            { value: 1, label: 'Lezárt' },
          ],
          valueKey: 'value',
          labelCallback: option => option && option.label,
          defaultSearch: true,
          filterInput: 0,
        },
        {
          type: 'select',
          name: 'source',
          label: 'Forrás',
          options: sourceOptions,
          valueKey: 'value',
          labelCallback: option => option && option.label,
        },
        {
          type: 'select',
          name: 'severity',
          label: 'Súlyosság',
          options: severityOptions,
          valueKey: 'value',
          labelCallback: option => option && option.label,
        },
        {
          type: 'text',
          name: 'search',
          label: 'Keresés',
        },
      ],
    };
  },
  computed: {
    errorLogs() {
      return this.$store.getters['errorLog/paginatedErrorLogs'] || {};
    },
    loading() {
      return this.$store.getters['errorLog/loading'];
    },
  },
  async mounted() {
    await this.$store.dispatch('errorLog/fetchAllWithPagination', '?resolved=0');
  },
  methods: {
    sourceLabel,
    severityLabel,
    severityTagType,
    entityLabel,
    resolverName(row) {
      if (row.resolved_by && (row.resolved_by.last_name || row.resolved_by.first_name)) {
        return ` (${row.resolved_by.last_name || ''} ${row.resolved_by.first_name || ''})`.trimEnd();
      }
      return '';
    },
    showMessage(row) {
      this.selectedMessage = row.message;
      this.messageDialogVisible = true;
    },
    async copyMessage() {
      try {
        await navigator.clipboard.writeText(this.selectedMessage);
        this.$messageWrapper.success('Vágólapra másolva');
      } catch (e) {
        this.$messageWrapper.error('A másolás nem sikerült');
      }
    },
    async showXml(id) {
      this.xmlFileName = '';
      this.selectedXmlContent = '';
      this.xmlDialogVisible = true;
      this.xmlLoading = true;
      try {
        const { file_name, file_content } = await this.$store.dispatch('errorLog/fetchXml', id);
        this.xmlFileName = file_name;
        this.selectedXmlContent = file_content;
      } catch (e) {
        this.xmlDialogVisible = false;
      }
      this.xmlLoading = false;
    },
    async copyXml() {
      try {
        await navigator.clipboard.writeText(this.selectedXmlContent);
        this.$messageWrapper.success('Vágólapra másolva');
      } catch (e) {
        this.$messageWrapper.error('A másolás nem sikerült');
      }
    },
    handleCurrentChange(val) {
      this.$store.commit('errorLog/setCurrentPage', val);
      this.$store.dispatch('errorLog/fetchAllWithPagination');
    },
  },
};
</script>
